import { defineMessages } from 'react-intl';

export default defineMessages({
	body: {
		id: 'paymentTermsAndConditions.body',
		defaultMessage:
			"By clicking this box, you agree to Calm's <msalink>Master Services Agreement</msalink>, <dpalink>Data Processing Addendum</dpalink>, and to be automatically billed for your first year of Calm's services, which will then automatically renew at the then current price every year until canceled. Contact <supportlink>Calm</supportlink> to manage your subscription.",
		description:
			'Text next to a checkbox that the user must agree to in order to proceed with payment. This text is a legal agreement that the user is accepting by checking the box.',
	},
	error: {
		id: 'paymentTermsAndConditions.error',
		defaultMessage: 'Please click the box indicating you agree to the terms and agreements',
		description:
			'Error message displayed when the user tries to proceed without agreeing to the terms and conditions.',
	},
});
